import SquareIcon from '@mui/icons-material/Square';
import { ListItemIcon, MenuItem, TextField } from '@mui/material';
import { L } from 'harmony-language';
import React from 'react';

interface ColorSelectorProps {
    value: string;
    onChange: (color: string) => void;
    colors: string[];
}

export const ColorSelector = (props: ColorSelectorProps) => (
    <TextField
        label={L.color()}
        variant='standard'
        select
        value={props.value}
        onChange={(e) => props.onChange(e.target.value)}
        fullWidth
        required
        style={{ maxWidth: '5rem' }}
    >
        {props.colors.map(color => (
            <MenuItem key={color} value={color}>
                <ListItemIcon>
                    <SquareIcon style={{ color: color }} />
                </ListItemIcon>
            </MenuItem>
        ))}
    </TextField>
);